<!-- eslint-disable @angular-eslint/template/no-call-expression  -->

<div class="flex h-full w-full flex-col">
  <!-- Form Content -->
  <div class="flex h-full flex-1">
    <!-- Sidebar -->
    <div
      class="min-w-72 flex w-72 flex-col border-r border-solid border-gray-200"
    >
      <div class="sticky top-0 h-full overflow-y-auto py-4">
        <div class="flex flex-col">
          @for (step of steps; track step.title; let idx = $index) {
            <div
              class="relative flex cursor-pointer items-center p-4 px-6 hover:bg-gray-100"
              [ngClass]="
                activeStepIndex() === idx
                  ? 'text-primary-500 before:bg-primary-500 before:absolute before:left-0 before:top-1/2 before:h-1/2 before:w-1 before:-translate-y-1/2 before:rounded'
                  : ''
              "
              (click)="setActiveStep(idx)"
            >
              <div class="flex items-center gap-4">
                @if (stepValidities()[idx] && disabled() === false) {
                  <mat-icon class="text-green-500">check_circle</mat-icon>
                }
                <div class="text-base text-gray-500">
                  {{ step.title }}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Form Container -->
    <div class="flex min-h-0 flex-1 flex-col">
      <div class="mb-6 flex flex-1 flex-col overflow-y-auto p-6">
        <!-- Form Header -->
        <h1 class="mb-6 !font-bold">
          {{ steps[activeStepIndex()].title }}
        </h1>

        <!-- Form Steps -->
        <div class="min-h-0 flex-1">
          @switch (activeStepIndex()) {
            @case (0) {
              <pr-acc-patient-reference-form
                [form]="patientReferenceForm"
                [metadata]="metadata()"
                [disabled]="disabled()"
                [testMode]="testMode()"
                [sendingForms]="sendingForms()"
                (sendPatientFormsChange)="sendPatientForms($event)"
              />
            }
            @case (1) {
              <pr-acc-patient-form
                [form]="patientForm"
                [disabled]="disabled()"
              />
            }
            @case (2) {
              <pr-acc-injury-form [form]="injuryForm" />
            }
            @case (3) {
              <pr-acc-employment-step
                [employmentForm]="employmentForm"
                [workCapacityForm]="workCapacityForm"
                [disabled]="disabled()"
              />
            }
            @case (4) {
              <pr-acc-dental-diagnosis-form
                [form]="dentalDiagnosisForm"
                [disabled]="disabled()"
              />
            }
            @case (5) {
              <pr-acc-assistance-step
                [referralForm]="referralForm"
                [assistanceForm]="assistanceForm"
                [disabled]="disabled()"
              />
            }
            @case (6) {
              <pr-acc-summary-declaration-form
                [form]="summaryDeclarationForm"
                [patientReferenceForm]="patientReferenceForm"
                [patientForm]="patientForm"
                [injuryForm]="injuryForm"
                [employmentForm]="employmentForm"
                [workCapacityForm]="workCapacityForm"
                [dentalDiagnosisForm]="dentalDiagnosisForm"
                [referralForm]="referralForm"
                [assistanceForm]="assistanceForm"
                (editStep)="setActiveStep($event)"
              />
            }
          }
        </div>
      </div>

      <!-- Form Navigation -->
      <div
        class="flex items-center gap-4 border-t border-solid border-gray-200 p-6"
      >
        <button
          mat-stroked-button
          [disabled]="saveDraftButtonDisabled()"
          (click)="saveProgress()"
        >
          Save Draft
        </button>

        <span class="flex-1"></span>

        @if (activeStepIndex() > 0) {
          <button mat-stroked-button (click)="previous()">Previous</button>
        }
        @if (activeStepIndex() < steps.length - 1) {
          <button
            color="primary"
            mat-flat-button
            [disabled]="!currentStepValid() || disabled()"
            (click)="next()"
          >
            Next
          </button>
        } @else if (activeStepIndex() === steps.length - 1) {
          <button
            color="primary"
            mat-flat-button
            [disabled]="submitButtonDisabled()"
            (click)="submitForm()"
          >
            {{ submitButtonText() }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
